export const brainChildWhite = "#FFFFFF";
export const brainChildBlack = "#000000";
export const brainChildRed = "#C53B32";
